import React from "react";
import TimeSlot from "./TimeSlot";
import { AvailableTimeSlot } from "../../features/sessions/time-slot/models/AvailableTimeSlot";
import {
  getDateAndDisplayTimeLabelInUserTimezone,
  formatTimeInUserTimezone,
} from "../../features/utils/timezoneUtils";
import DateDisplayCard from "./DateDisplayCard";

interface DayTimeSlotsProps {
  date: Date;
  timeSlots: AvailableTimeSlot[];
}

const DayTimeSlots: React.FC<DayTimeSlotsProps> = ({ date, timeSlots }) => {
  const dateLabelAndDisplayTime = getDateAndDisplayTimeLabelInUserTimezone(
    date.toISOString()
  );

  return (
    <div className="flex h-full gap-4 lg:gap-6">
      <DateDisplayCard
        dateLabel={dateLabelAndDisplayTime.label}
        dateDisplay={dateLabelAndDisplayTime.display}
      />
      <div className="grid w-full grid-cols-2 items-center gap-4 min-[420px]:grid-cols-3">
        {timeSlots.slice(0, 6).map((slot) => {
          // Generate local time range from UTC dateStart and duration
          const startTime = formatTimeInUserTimezone(slot.dateStart);
          const endDate = new Date(
            new Date(slot.dateStart).getTime() + slot.duration * 60000
          );
          const endTime = formatTimeInUserTimezone(endDate.toISOString());
          const timeRange = `${startTime} - ${endTime}`;

          return (
            <TimeSlot
              key={slot.dateStart}
              time={timeRange}
              selectedDate={date}
              duration={slot.duration}
              disabled={false}
            />
          );
        })}
      </div>
    </div>
  );
};

export default DayTimeSlots;
